/**
 * Orka V3 — Agent Tone grammar (Code Reference §3.5, PRD §6.6).
 *
 * The five-colour grammar used across ALL AI/agent surfaces.
 * Removes duplicates from FloatingChat, AIPage, ThinkingPanel, etc.
 */
export const AGENT_TONES = Object.freeze({
  thinking: {
    key: 'thinking',
    label: 'Thinking',
    color: '#7c3aed',
    soft: '#7c3aed22',
    border: '#7c3aed77',
  },
  running: {
    key: 'running',
    label: 'Running',
    color: '#0284c7',
    soft: '#0284c722',
    border: '#0284c777',
  },
  awaiting: {
    key: 'awaiting',
    label: 'Needs you',
    color: '#d97706',
    soft: '#d9770622',
    border: '#d9770677',
  },
  done: {
    key: 'done',
    label: 'Done',
    color: '#059669',
    soft: '#05966922',
    border: '#05966977',
  },
  failure: {
    key: 'failure',
    label: 'Failed',
    color: '#dc2626',
    soft: '#dc262622',
    border: '#dc262677',
  },
});

export const AGENT_TONE_KEYS = Object.freeze(Object.keys(AGENT_TONES));

export function getAgentTone(key) {
  return AGENT_TONES[key] || AGENT_TONES.thinking;
}

/** CSS-vars helper (Code Reference §11.1). */
export function toneVars(toneKey) {
  const tone = getAgentTone(toneKey);
  return {
    '--tone-color': tone.color,
    '--tone-soft': tone.soft,
    '--tone-border': tone.border,
  };
}
